// extracted by mini-css-extract-plugin
export default {"appContainer":"app_appContainer__P7YEM","mainContent":"app_mainContent__sm9p3","pageContent":"app_pageContent__hPTxk"};